import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, ReplaySubject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonUtility } from 'src/app/_modules/commonUtility';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
 

  progressBar: Boolean = true;
  Tok
  AthTokenValue: string;
  decodedToken: any;
  expirationDate: Date;
  isExpired: boolean;
  key;
  data;
  production: true;
  error_desc: string;
  ACS_url;
  Base_url;
  AuthToken;
  commonUtility: CommonUtility;
  helper = new JwtHelperService();
  bankName: any;

  private httpLoading$ = new ReplaySubject<boolean>(1);
  // TOK: string;
  constructor(
    private snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router,
    private matDialog: MatDialog
  ) {
    this.key = environment.key;
    this.ACS_url = environment.ACS_URL;
    this.Base_url = environment.Base_url;
    this.commonUtility = new CommonUtility(snackBar);
  }



  tkn
  ngOninIt() {
    this.bankName = localStorage.getItem('bankName');
    console.log('bankName common service ', this.bankName);
  }

  encry(DATA) {
    //console.log("Data : " + DATA);
    this.data = DATA;
    let _Key = CryptoJS.enc.Utf8.parse(this.key);
    var iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0]); //CryptoJS.enc.Utf8.parse(this.key);
    let encrypted = CryptoJS.AES.encrypt(
      this.data,
      _Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC
    }).toString();
    return encrypted
  }
  passEncry(DATA, uname) {
    var pass = CryptoJS.SHA512(DATA + uname);
    return pass
  }

  decodeToken(token) {
    var decoded = jwtDecode(token);
    return decoded;
  }

  decrypt(DATA) {
    //console.log("Data : " + DATA);
    let _Key = CryptoJS.enc.Utf8.parse(this.key);
    var iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0]);
    let decrypted = CryptoJS.AES.decrypt(
      DATA, _Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);
    //console.log("Decrypted --> "+decrypted);
    return decrypted;

  }


  funSessionExpired(errorDesc) {
    localStorage.setItem('authorizationToken', '');
    this.error_desc = errorDesc;
    this.matDialog.closeAll();
    //this.router.navigate(["../pnb"]);
    this.router.navigate([`../${this.bankName}`]);
  }

  checkSessionValid() {
    const helper = new JwtHelperService();
    const token = localStorage.getItem('authorizationToken');
    if (token == null) {
      this.commonUtility.alertMsg("Token Required. Please Login!!", "", false);
      this.matDialog.closeAll();
      localStorage.clear();
      //this.router.navigate(['']);
      this.router.navigate([`${this.bankName}`]);
      return false;
    } else {
      try {
        const isExpired: boolean = helper.isTokenExpired(token);
        if (isExpired) {
          this.commonUtility.alertMsg("Expired Token. Please Login!!", "", false);
          this.matDialog.closeAll();
          localStorage.clear();
          //this.router.navigate(['']);
          this.router.navigate([`${this.bankName}`]);
          return false;
        }
      } catch (Error) {
        this.commonUtility.alertMsg("In-Valid Token. Please Login!!", "", false);
        this.matDialog.closeAll();
        localStorage.clear();
        //this.router.navigate(['']);
        this.router.navigate([`${this.bankName}`]);
        return false;
      }
    }
    return true;
  }

  Login2FA(req) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })

    let url = `${this.ACS_url}auth/slt`
    return this.http.post<any>(url, req, {
      headers: headers,
      observe: 'response'
    })
  }

  getUserId(req) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })

    let url = `${this.ACS_url}auth/2fa/slt`
    return this.http.post<any>(url, req, {
      headers: headers,
      observe: 'response'
    })
  }

  getUserIdwithToken(req, confirm) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',

    })
    let url = `${this.ACS_url}auth/2fa/slt?tokenFlag=` + confirm
    return this.http.post<any>(url, req, { headers: headers, observe: 'response' })
  }

  setformControlError(formcontrol: any, controlName: string) {
    formcontrol.controls[controlName].markAsDirty();
    formcontrol.controls[controlName].markAsTouched();
    formcontrol.controls[controlName].setErrors({ 'invalid': true });
  }

  getFormControlError(formcontrol: any, controlName: string) {
    return formcontrol.controls[controlName].invalid && (formcontrol.controls[controlName].dirty || formcontrol.controls[controlName].touched);
  }

  httpProgress(): Observable<boolean> {
    return this.httpLoading$.asObservable();
  }

  setHttpProgressStatus(inprogess: boolean) {
    this.httpLoading$.next(inprogess);
  }

  uploadFile(req: any,id:any):Observable<any> {
    const formData = new FormData();
    formData.append("formId", id);
    formData.append("file", req.name);

    let headers = new HttpHeaders({
    })

    let url = `${this.ACS_url}uploadExcel`
    return this.http.post<any>(url, formData, {
      headers: headers,
    })

  }

  fetchAllFormDetails():Observable<any> {
        let url = `${this.ACS_url}fetchAllFormDetails`
    return this.http.get(url, {
      responseType : "json",
    })
  }
}